@if (show) {
  <div
    [ngClass]="serviceGroup.total.class"
    class="flex flex-col items-center justify-between p-2 print:service-group-total bg-th-accent md:p-6 md:flex-row">
    <div class="text-sm md:text-lg">{{ serviceGroup.total.label | translate }}</div>
    <div class="">{{ serviceGroup.total.value | translate }}</div>
  </div>
}
